/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum models_EntityStatus {
    StatusActive = 'ACTIVE',
    StatusInactive = 'INACTIVE',
    StatusUpcoming = 'UPCOMING',
    StatusDeleted = 'DELETED',
}
